<!-- BODY HEADER SECTION -->
<div class="iot-platform-ui-chat-body" data-cy="iot-platform-ui-chat-body" fxFlex fxLayout="column">
  <section class="iot-platform-ui-chat-body__header">
    @if (body().header?.ref) {
      @if (body().header?.inputs) {
        <ng-container *ngComponentOutlet="$safeNavigationMigration(body().header?.ref); inputs: $safeNavigationMigration(body().header?.inputs)" />
      } @else {
        <ng-container [ngTemplateOutlet]="$safeNavigationMigration(body().header?.ref)" />
      }
    }
  </section>
  <!-- BODY CONTENT SECTION -->
  <section class="iot-platform-ui-chat-body__content" fxFlex>
    @if (body()?.content?.ref) {
      @if (body()?.content?.inputs) {
        <ng-container *ngComponentOutlet="$safeNavigationMigration(body().content?.ref); inputs: $safeNavigationMigration(body?.()?.content?.inputs)" />
      } @else {
        <ng-container [ngTemplateOutlet]="$safeNavigationMigration(body().content?.ref)" />
      }
    } @else {
      @if (!!body()?.content?.messages?.()?.length) {
        <div #chatBody class="iot-platform-ui-chat-body__content_messages" fxFlex>
          <div fxLayout="column" fxLayoutGap="14px">
            @for (message of body()?.content?.messages?.(); track $index) {
              @if (message?.ref) {
                @if (message?.inputs) {
                  <ng-container *ngComponentOutlet="$safeNavigationMigration(message?.ref); inputs: $safeNavigationMigration(message?.inputs)" />
                } @else {
                  <ng-container [ngTemplateOutlet]="$safeNavigationMigration(message?.ref)" />
                }
              } @else {
                <iot-platform-ui-chat-message [message]="message" (dispatchAction)="dispatchAction.emit($event)" />
              }
            }
            @if (body()?.content?.loading?.() && body()?.content?.conversationLoader?.()) {
              <iot-platform-ui-chat-conversation-loader />
            }
          </div>
        </div>
      } @else if (body()?.content?.emptyBodyLabel?.()) {
        <div class="iot-platform-ui-chat-body__content_no_messages" fxLayoutAlign="center center" fxFlex fxLayout="column">
          {{ $safeNavigationMigration(body()?.content?.emptyBodyLabel?.()) | translate }}
        </div>
      }
    }
  </section>
</div>
